import store from "@/store";

export function PermissionExistsStore(permission = undefined) {
  return typeof permission === "string"
    ? store.getters["auth/permissions"].includes(permission)
    : false;
}
